import React from 'react';
import { FormattedMessage, MessageDescriptor } from 'react-intl';
import PrimaryButton from '../form-components/PrimaryButton/PrimaryButton';
import { IPopupable } from '../Popup/Popup';
import globalMessages from 'src/services/globalMessages';


interface ISuccessMessageProps extends IPopupable {
    message: MessageDescriptor;
    buttonCaption?: MessageDescriptor;
}

const SuccessMessage: React.FunctionComponent<ISuccessMessageProps> = ({ closePopup, message, buttonCaption = globalMessages.ok }) => {

    const handleOk = () => {
        closePopup?.();
    }

    return (
        <section className="success-message">
            <p className="success-message__text"><FormattedMessage {...message} /></p>
            <div className="success-message__buttons">
                <PrimaryButton className="success-message__button" onClick={handleOk} caption={buttonCaption} />
            </div>
        </section>
    )
}

export default SuccessMessage;
